import React from 'react';
import styled from 'styled-components';

import CarrotToggle from 'library/components/carrot-toggle';
import iconSvgName from 'apps/journey/util/icon-svg-name';
import Icons from 'apps/journey/icons/icons';
import { BodyText } from 'library/components/text-elements';
import {
  StyledContainer,
  StyledList,
  StyledItem,
  StyledHeader,
  StyledRowHeader,
} from './styles';

const StyledCarrotToggle = styled(CarrotToggle)`
  padding: 0;
`;

const GoalItem = ({ goal, selectedGoal, setSelected, isCollapsed }) => {
  const selectGoal = (e) => {
    if (goal != selectedGoal) setSelected(goal);
    else setSelected(null);
  };

  const Icon = goal.icon ? Icons[iconSvgName(goal.icon)] : null;

  return (
    <StyledItem className={selectedGoal == goal && 'highlighted'}>
      <StyledRowHeader>
        {Icon && <Icon fill="#32AC88" className="icon" />}
        <BodyText bold>{goal.name}</BodyText>
      </StyledRowHeader>
      <StyledCarrotToggle
        direction="right"
        active={selectedGoal == goal}
        onClick={selectGoal}
        tabIndex={isCollapsed ? '0' : '-1'}
      />
    </StyledItem>
  );
};

const Goals = ({ goals, selectedGoal, setSelected, isCollapsed }) => (
  <StyledContainer className={selectedGoal ? 'half-width' : 'full-width'}>
    <StyledHeader>Goals</StyledHeader>

    <StyledList>
      {goals.map((goal) => (
        <GoalItem
          goal={goal}
          selectedGoal={selectedGoal}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
          key={goal.id}
        />
      ))}
    </StyledList>
  </StyledContainer>
);

export default Goals;
